import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import { RemoveSpaceGroupMemberModalComponent } from "./RemoveSpaceGroupMemberModalComponent";
import type { RemoveSpaceGroupMemberModalProps } from "./types";

const RemoveSpaceGroupMemberModal = ModalManager.create(
  (props: RemoveSpaceGroupMemberModalProps) => (
    <RemoveSpaceGroupMemberModalComponent {...props} />
  ),
);

export const useRemoveSpaceGroupMemberModal = () =>
  useModal(RemoveSpaceGroupMemberModal);
